import React from 'react';
import { Button } from './Button';
import { Shield, Scale, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-legal-dark text-white py-16 md:py-24 overflow-hidden" data-id="element-142">
      {/* Subtle background pattern/overlay */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-143"></div>

      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-144">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-145">
          <div className="lg:col-span-7 space-y-8" data-id="element-146">
            <div className="inline-flex items-center space-x-2 bg-white/10 px-3 py-1 rounded-full text-sm font-medium text-gray-200 border border-white/20" data-id="element-147">
              <Scale className="w-4 h-4 text-legal-red" data-id="element-148" />
              <span data-id="element-149">National Truck Accident Law Firm</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white" data-id="element-150">
              The Federal Motor Carrier Safety Regulations (FMCSR)
            </h1>

            <div className="space-y-4 text-lg md:text-xl text-gray-300 font-light max-w-2xl" data-id="element-151">
              <p data-id="element-152">
                Someone could say 'We wrote the book, we are connected, and we
                do our research'.
              </p>
              <p data-id="element-153">
                We have extensively researched, worked with, and associated with
                the finest trucking injury attorneys across the country.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-154">
              <Button href="tel:18007085433" variant="primary" size="lg" icon="phone" data-id="element-155">
                Call Now: 1-800-708-5433
              </Button>
              <Button href="11014.html" variant="outline" size="lg" icon="mail" className="border-white text-white hover:bg-white hover:text-legal-dark" data-id="element-156">
                Contact Us About Your Case
              </Button>
            </div>

            <div className="flex items-center space-x-2 text-sm text-gray-400 pt-2" data-id="element-157">
              <Clock className="w-4 h-4" data-id="element-158" />
              <span data-id="element-159">Speak to Attorney Jason Waechter personally.</span>
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-160">
            <div className="bg-white rounded-lg shadow-2xl p-8 text-legal-dark border-t-4 border-legal-red" data-id="element-161">
              <div className="flex justify-center mb-6" data-id="element-162">
                <div className="w-16 h-16 bg-legal-light rounded-full flex items-center justify-center" data-id="element-163">
                  <Shield className="w-8 h-8 text-legal-red" data-id="element-164" />
                </div>
              </div>
              <h2 className="text-2xl font-bold text-center mb-4" data-id="element-165">
                Need Immediate Help?
              </h2>
              <p className="text-center text-legal-gray mb-8" data-id="element-166">
                Trucking companies have rapid response teams. You need one too.
                Contact us for a free, confidential case assessment.
              </p>
              <div className="space-y-4" data-id="element-167">
                <Button href="tel:18007085433" variant="primary" className="w-full justify-center" icon="phone" data-id="element-168">
                  1-800-708-5433
                </Button>
                <Button href="11014.html" variant="secondary" className="w-full justify-center" icon="mail" data-id="element-169">
                  Get a Free Case Assessment
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}